import { ActionTypes } from "./costants";

export const changeLanguage = (language) => {
    return {
        type: ActionTypes.CHANGE_LANGUAGE,
        payload: language,
    };
};